export const FETCH_TRANSACTIONS_DATAPOINTS = "FETCH_TRANSACTIONS_DATAPOINTS";
export const FETCH_TRANSACTIONS_DATAPOINTS_PENDING = "FETCH_TRANSACTIONS_DATAPOINTS_PENDING";
export const FETCH_TRANSACTIONS_DATAPOINTS_FULFILLED = "FETCH_TRANSACTIONS_DATAPOINTS_FULFILLED";
export const FETCH_TRANSACTIONS_DATAPOINTS_REJECTED = "FETCH_TRANSACTIONS_DATAPOINTS_REJECTED";

export const RESET_TRANSACTIONS_DATAPOINTS = "RESET_TRANSACTIONS_DATAPOINTS";
